<app-page-heading [heading]="heading"
                  [hasBackButton]="true"
                  [backPageName]="backPageName"
                  [tabName]="tabName">
</app-page-heading>

<!---------------------------->
<!-- Section Banner-->
<!---------------------------->
<ng-container *ngIf="!isAllowedToSubmit()">
  <app-banner [bannerText]="bannerText"></app-banner>
</ng-container>


<div class="stepper-container">
  <mat-horizontal-stepper #stepper [linear]="true">

    <!---------------------------->
    <!-- STEP: General:-->
    <!---------------------------->

    <mat-step #generalStep [completed]="generalFormGroup.valid">
      <ng-template matStepLabel>General</ng-template>
      <form [formGroup]="generalFormGroup">
        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Name</mat-label>
              <input matInput type="text" [formControl]="providerNameFormControl"
                (blur)="blurProviderOrProviderGroupHeading()" required>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Name')">help_outline</mat-icon>
          </mat-grid-tile>

          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Entity Status</mat-label>
              <mat-select [formControl]="entityStatusFormControl" required>
                <mat-option *ngFor="let item of entityStatus" [value]="item.name">
                  {{item.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Entity Status')">help_outline</mat-icon>
          </mat-grid-tile>

        </mat-grid-list>

        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Practice Number</mat-label>
              <input matInput type="text"
                     [formControl]="practiceNumberFormControl"
                     [required]="providerIsMedical()"
                     [placeholder]="providerIsMedical() ? 'Enter a UNIQUE number' : 'Enter a UNIQUE number  - leave blank if unknown' ">
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Practice Number')">help_outline</mat-icon>
          </mat-grid-tile>
          <mat-grid-tile>
            <greydom-date-picker
              label="Start Date of Provider"
              [required]="true"
              [formControl]="startDateFormControl"
              [tooltip]="getInfoTooltip('Start Date')"
              [maxDate]="endDateFormControl.value">
            </greydom-date-picker>
          </mat-grid-tile>
        </mat-grid-list>
        <mat-grid-list cols="2" rowHeight="75px">

          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Business Type</mat-label>
              <mat-select [formControl]="businessTypeFormControl" required>
                <mat-option *ngFor="let type of businessType" [value]="type.name">
                  {{type.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Business Type')">help_outline</mat-icon>
          </mat-grid-tile>
          <mat-grid-tile>
            <greydom-date-picker
              label="End Date of Provider"
              [formControl]="endDateFormControl"
              [tooltip]="getInfoTooltip('End Date')"
              [minDate]="startDateFormControl.value">
            </greydom-date-picker>
          </mat-grid-tile>
        </mat-grid-list>
        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Regulator</mat-label>
              <mat-select [formControl]="regulatorFormControl" required>
                <mat-option *ngFor="let item of regulator" [value]="item.name">
                  {{item.name}}
                </mat-option>
              </mat-select>

            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Regulator')">help_outline</mat-icon>
          </mat-grid-tile>
          <mat-grid-tile *ngIf="isProvider">
            <label>Part of a Group</label>
            <mat-radio-group [(ngModel)]="partOfGroup" [ngModelOptions]="{standalone: true}"
              aria-label="Select yes OR no" class="example-radio-group" [disabled]="disablePartOfGroupRadioGroup()"
              [matTooltip]="disablePartOfGroupRadioGroup() ? 'Please select an end date before removing from group' : getInfoTooltip('Part of a Group')">
              <mat-radio-button class="radio-button" style="margin-left: 16px;" value="Yes">Yes</mat-radio-button>
              <mat-radio-button class="radio-button" style="margin-left: 16px;" value="No" checked>No</mat-radio-button>
            </mat-radio-group>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Part of a Group')">help_outline</mat-icon>
          </mat-grid-tile>
        </mat-grid-list>
        <mat-grid-list *ngIf="isProvider" cols="2" rowHeight="75px">

          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Facility Type</mat-label>
              <mat-select [formControl]="providerFacilityTypeFormControl" required>
                <mat-option *ngFor="let providerFacilityType of facilityTypes" [value]="providerFacilityType.name">
                  {{providerFacilityType.name}}
                </mat-option>
              </mat-select>

            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Provider Facility Type')">help_outline</mat-icon>
          </mat-grid-tile>
          
          <mat-grid-tile *ngIf="isProvider && partOfGroup  === 'Yes'">
            <mat-form-field class="w-35">
              <mat-label>Group Name</mat-label>
              
              <input matInput type="text" [placeholder]="getInfoTooltip('Group Name')"
                     [formControl]="providerGroupFormControl" (input)="onInputChangedSearchProviderGroup($event)"
                     [matAutocomplete]="providerGroupAuto" [required]="isProvider">
              <mat-autocomplete #providerGroupAuto="matAutocomplete" [panelWidth]="'40vw'">
                <mat-option (onSelectionChange)="providerGroupSelected($event.source.value)"
                            *ngFor="let providerGroup of providerGroupDataSource" [value]="providerGroup"
                            class="custom-mat-option">
                  {{providerGroup.name}}
                </mat-option>
              </mat-autocomplete>
              <button (click)="clearProviderGroup()" *ngIf="providerGroupFormControl.value" aria-label="Clear"
                      mat-button mat-icon-button matSuffix>
                <mat-icon style="color: grey;">clear</mat-icon>
              </button>
            
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Group Name')">help_outline</mat-icon>
            
            <div>
              <button class="m-l-5 add-note" mat-raised-button color="primary"
                      (click)="onClickOpenAddNoteDialog($event)">
                <mat-icon>note_add</mat-icon>
                Add Note
              </button>
            </div>
          </mat-grid-tile>
          
        </mat-grid-list>

        <mat-grid-list cols="2" rowHeight="75px">

          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Processing Class</mat-label>

              <mat-select [formControl]="processingClassFormControl" required
                          (selectionChange)="processingClassSelected($event.source.value)">
                <mat-option *ngFor="let processingClass of processingClasses" [value]="processingClass.name">
                  {{processingClass.name}}
                </mat-option>
              </mat-select>

            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Processing Class')">help_outline</mat-icon>
          </mat-grid-tile>

          <mat-grid-tile *ngIf="isProvider && partOfGroup  === 'Yes'">
            <mat-form-field style="width: 12vw; margin-right: 1vw">
              <mat-label>Start Date on Group</mat-label>
              <input [formControl]="startDateGroupFormControl" (dateChange)="startDateChangeOnProviderGroup()"
                     [required]="isProvider && partOfGroup  === 'Yes'"
                     [max]="endDateGroupFormControl.value"
                     [matDatepicker]="generalGroupStartDatePicker" matInput>
              <mat-datepicker-toggle [for]="generalGroupStartDatePicker" matIconSuffix>
              </mat-datepicker-toggle>
              <mat-datepicker #generalGroupStartDatePicker></mat-datepicker>
            </mat-form-field>

            <mat-form-field style="width: 12vw">
              <mat-label>End Date on Group</mat-label>
              <input [formControl]="endDateGroupFormControl" (dateChange)="endDateChangeOnProviderGroup()"
                     [min]="startDateGroupFormControl.value"
                     [matDatepicker]="generalGroupEndDatePicker" matInput>
              <mat-datepicker-toggle [for]="generalGroupEndDatePicker" matIconSuffix>
              </mat-datepicker-toggle>
              <mat-datepicker #generalGroupEndDatePicker></mat-datepicker>
            </mat-form-field>
            <mat-icon [matTooltip]="getInfoTooltip('Provider Group Dates')" class="info-icon">help_outline</mat-icon>
          </mat-grid-tile>
        </mat-grid-list>

        <mat-grid-list cols="2" rowHeight="75px">

          <mat-grid-tile *ngIf="shouldShowProviderNetworkList">
              <app-content-field [content]="providerNetworkList" [label]="'Provider Network'"></app-content-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Provider Netwoks Readonly')">help_outline</mat-icon>
          </mat-grid-tile>

          <mat-grid-tile *ngIf="isProvider && partOfGroup  === 'Yes'">
            <div>
              <div>
                <label>Use Group Price List</label>
                <mat-radio-group [(ngModel)]="useGroupPriceList" [ngModelOptions]="{standalone: true}"
                                 aria-label="Select yes OR no" [disabled]="disableProviderGroupPriceListRadioGroup()"
                                 [matTooltip]="disableProviderGroupPriceListRadioGroup() ? 'The selected group has no price list' : getInfoTooltip('Use Group Price List')"
                                 class="example-radio-group">
                  <mat-radio-button class="radio-button" style="margin-left: 20px;" value="Yes">
                    Yes
                  </mat-radio-button>
                  <mat-radio-button class="radio-button" style="margin-left: 16px;" value="No" checked>
                    No
                  </mat-radio-button>
                </mat-radio-group>
                <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Use Group Price List')">help_outline</mat-icon>
              </div>

              <div>
                <label>Pay Group</label>
                <mat-radio-group [(ngModel)]="payGroup" [ngModelOptions]="{standalone: true}" aria-label="Select yes OR no"
                                 class="example-radio-group">
                  <mat-radio-button class="radio-button" style="margin-left: 20px;" value="Yes">
                    Yes
                  </mat-radio-button>
                  <mat-radio-button class="radio-button" style="margin-left: 16px;" value="No" checked>
                    No
                  </mat-radio-button>
                </mat-radio-group>
                <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Pay Group')">help_outline</mat-icon>
              </div>
            </div>
          </mat-grid-tile>
        </mat-grid-list>

        <div *ngIf="providerId && getProviderGroupHistoryToDisplay().length > 0">
          <mat-divider></mat-divider>
          <div style="width: 46%; float: right;">
              <div class="history-column  m-b-15">
                <div class="mat-primary-color m-t-15 m-b-15">
                    <label class="history-label">Provider Group History</label>
                </div>
                <div *ngFor="let providerGroup of getProviderGroupHistoryToDisplay()" class="status-history-section">
                  <div class="history-date-width">
                  {{providerGroup?.providerGroupDTO.name}}: {{providerGroup?.startDate | date: 'yyyy/MM/dd'}} - {{providerGroup?.endDate | date: 'yyyy/MM/dd'}}
                  </div>
                </div>
              </div>
          </div>
        </div>

        <div class="button-container">
          <button mat-raised-button color="warn" (click)="resetGeneralFormGroup()">Clear</button>
          <button mat-raised-button matStepperNext color="primary">Next</button>
        </div>
      </form>
    </mat-step>

    <!---------------------------->
    <!-- STEP: Address:-->
    <!---------------------------->

    <mat-step #addressStep [completed]="addressFormComponent?.selectedAddresses?.length>0">
      <ng-template matStepLabel>Addresses</ng-template>
      <greydom-address-form #addressFormComponent
                            [data]="isProvider ? selectedProvider : selectedProviderGroup">
      </greydom-address-form>
    </mat-step>

    <!---------------------------->
    <!-- STEP: Contacts:-->
    <!---------------------------->

    <mat-step #contactsStep [completed]="contactFormComponent?.selectedContacts?.length>0">
      <ng-template matStepLabel>Contacts</ng-template>
      <greydom-contact-form #contactFormComponent
                            [data]="isProvider ? selectedProvider : selectedProviderGroup">
      </greydom-contact-form>
    </mat-step>

    <!---------------------------->
    <!-- STEP: Statutory:-->
    <!---------------------------->

    <mat-step #statutoryStep [completed]="statutoryFormGroup.valid">
      <ng-template matStepLabel>Statutory</ng-template>
      <form [formGroup]="statutoryFormGroup">

        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Business License Number</mat-label>
              <input [formControl]="businessLicenseNumberFormControl" type="text" matInput required>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Business License Number')">help_outline</mat-icon>
          </mat-grid-tile>
          <mat-grid-tile class="align-left">
            <label>Vat Applicable </label>
            <mat-radio-group [(ngModel)]="vatApplicable" [ngModelOptions]="{standalone: true}"
              aria-label="Select yes OR no" class="example-radio-group">
              <mat-radio-button class="radio-button" style="margin-left: 20px;" value="Yes">
                Yes &nbsp;
              </mat-radio-button>
              <mat-radio-button class="radio-button" value="No" checked>
                No
              </mat-radio-button>
            </mat-radio-group>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('VAT Applicable')">help_outline</mat-icon>
          </mat-grid-tile>

        </mat-grid-list>


        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <greydom-date-picker
              label="Business License Expiry Date"
              [required]="true"
              [formControl]="businessLicenseExpiryFormControl"
              [tooltip]="getInfoTooltip('Business License Expiry Date')">
            </greydom-date-picker>
          </mat-grid-tile>
          <mat-grid-tile *ngIf="vatApplicable  === 'Yes'">
            <mat-form-field>
              <mat-label>Vat Number</mat-label>
              <input [formControl]="vatNumberFormControl" type="text" matInput>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('VAT Number')">help_outline</mat-icon>
          </mat-grid-tile>
        </mat-grid-list>
        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <mat-label style="margin-right: 5px;">License Copy</mat-label>
            <input id="onLicenseFileUpload" type="file" accept="image/jpeg,application/pdf" [disabled]="true"
              (change)="handleInputChangeForLicenseCopy($event)" />
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('License Copy')">help_outline</mat-icon>
          </mat-grid-tile>
          <mat-grid-tile>

            <mat-label>GST Applicable</mat-label>
            <mat-radio-group [(ngModel)]="gstApplicable" [ngModelOptions]="{standalone: true}"
              aria-label="Select a yes OR no" style="margin-left: 20px;" class="example-radio-group">
              <mat-radio-button class="radio-button " value="Yes">
                Yes &nbsp;
              </mat-radio-button>
              <mat-radio-button class="radio-button" value="No" checked>
                No
              </mat-radio-button>
            </mat-radio-group>

            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('GST Applicable')">help_outline</mat-icon>
          </mat-grid-tile>
        </mat-grid-list>
        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Sanction Check Reference Number</mat-label>
              <input [formControl]="sanctionCheckReferenceNumber" type="text" matInput>
            </mat-form-field>
            <mat-icon [matTooltip]="getInfoTooltip('Sanction Check Reference Number')" class="info-icon">help_outline
            </mat-icon>
          </mat-grid-tile>
          <mat-grid-tile *ngIf="gstApplicable === 'Yes'">
            <mat-form-field>
              <mat-label>GST Number</mat-label>
              <input [formControl]="gstNumber" type="text" matInput>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('GST Number')">help_outline</mat-icon>
          </mat-grid-tile>
        </mat-grid-list>
        <mat-grid-list cols="2" rowHeight="75px">
          <mat-grid-tile>
            <div class="align-center" style="margin-top: 40px;">
              <button mat-raised-button style="width: auto !important;" color="warn">Sanction checker</button>
            </div>
          </mat-grid-tile>
          <mat-grid-tile></mat-grid-tile>
        </mat-grid-list>

        <div class="button-container">
          <button #statutoryBackButton mat-raised-button matStepperPrevious color="primary">Back</button>
          <button mat-raised-button color="warn" (click)="resetStatutoryFormGroup()">Clear</button>
          <button mat-raised-button matStepperNext color="primary">Next</button>
        </div>
      </form>
    </mat-step>

    <!---------------------------->
    <!-- STEP: Specialities:-->
    <!---------------------------->

    <mat-step *ngIf="isProvider" #specialitiesStep [optional]="!providerIsMedical()"
        [completed]="providerIsMedical() ? this.selectionControl.selected.length > 0 : true" >
      <ng-template matStepLabel>Specialities</ng-template>
      <div class="header-container">
        <p>Select specialities using the filter and sort functions</p>
        <span class="header-spacer"></span>
      </div>

      <div>
        <mat-slide-toggle #toggleSelectedSpecialities
          [(ngModel)]="showSelectSpecialities"
          (change)="toggleShowSelectedProviderSpecialities()">
          Selected Specialities
        </mat-slide-toggle>
      </div>

      <br/>

      <div *ngIf="providerSpecialityDataSource" class="mat-elevation-z8 table-container">
        <table mat-table multiTemplateDataRows [dataSource]="providerSpecialityDataSource"
          matSort (matSortChange)="sortData($event)">

          <ng-container [matColumnDef]="tableColumns.Select">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let row">
              <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="onCheckboxChange($event, row)"
                [checked]="isSelected(row)">
              </mat-checkbox>
            </td>
          </ng-container>

          <ng-container [matColumnDef]="tableColumns.ProviderSpecialityId">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>ID</th>
            <td *matCellDef="let row" mat-cell>{{row.providerSpecialityId}}</td>
          </ng-container>

          <ng-container [matColumnDef]="tableColumns.ProviderCode">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>
              <textarea matInput class="table-column-filter"
                        #autosize="cdkTextareaAutosize" cdkTextareaAutosize
                        cdkAutosizeMinRows="1" cdkAutosizeMaxRows="2"
                        #providerCodeSearch
                        (input)="onInputChangedFilterSpecialityData($event)"
                        (keydown.space)="$event.stopPropagation()"
                        (click)="$event.stopPropagation();"
                        placeholder="Discipline Code"
                        [(ngModel)]="providerCodeSearchValue"
                        [disabled]="showSelectSpecialities"></textarea>
            </th>
            <td *matCellDef="let row" mat-cell>{{row.providerCode}}</td>
          </ng-container>

          <ng-container [matColumnDef]="tableColumns.Speciality">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Discipline Description</th>
            <td *matCellDef="let row" mat-cell>{{row.speciality}}</td>
          </ng-container>

          <ng-container [matColumnDef]="tableColumns.SubSpecialityCode">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Sub-Discipline</th>
            <td *matCellDef="let row" mat-cell>{{row.subSpecialityCode}}</td>
          </ng-container>

          <ng-container [matColumnDef]="tableColumns.SubSpeciality">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Sub-Discipline Description</th>
            <td *matCellDef="let row" mat-cell>{{row.subSpeciality}}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="providerSpecialityDisplayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: providerSpecialityDisplayedColumns;"></tr>

        </table>

        <mat-paginator #providerSpecialityPaginator (page)="pageChanged($event)" [length]="providerSpecialityTableControl.length"
            [pageSize]="providerSpecialityTableControl.pageSize" [pageIndex]="0"
            [pageSizeOptions]="providerSpecialityTableControl.pageSizeOptions">
        </mat-paginator>

      </div>
      <div class="button-container">
        <button #statutoryBackButton mat-raised-button matStepperPrevious color="primary">Back</button>
        <button mat-raised-button color="warn" (click)="clearSelection()">Clear</button>
        <button mat-raised-button matStepperNext color="primary">Next</button>
      </div>
    </mat-step>

    <!---------------------------->
    <!-- STEP: Contract:-->
    <!---------------------------->

    <mat-step optional #contractStep [completed]="contractFormGroup.valid">
      <ng-template matStepLabel>Contracts</ng-template>
      <form [formGroup]="contractFormGroup">
        <mat-grid-list cols="2" [rowHeight]="listFormRowHeight">
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Contract Name</mat-label>
              <input [formControl]="contractNameFormControl" type="text" matInput>
            </mat-form-field>
            <mat-icon class="info-icon" [matTooltip]="getInfoTooltip('Contract Name')">help_outline</mat-icon>
          </mat-grid-tile>

          <mat-grid-tile>
            <greydom-date-picker
              label="Start Date"
              [required]="true"
              [formControl]="startDateContractFormControl"
              [tooltip]="getInfoTooltip('Start Date Contract')"
              [maxDate]="endDateContractFormControl.value">
            </greydom-date-picker>
          </mat-grid-tile>
        </mat-grid-list>

        <mat-grid-list cols="2" [rowHeight]="listFormRowHeight">

          <mat-grid-tile>
            <app-file-upload [config]="scanCopyFileUploadConfig" [customCssClasses]="['m-l-10','m-r-10']"
              (onUploadSuccess)="onFileUploadSuccess($event)">
            </app-file-upload>


            <ng-container *ngIf="scanCopyFileUploadConfig?.uploadedFileData?.file else noFileChoose">
              <a href target="#" (click)="downloadScanCopyFileUploadFile($event)">
                {{scanCopyFileUploadConfig?.uploadedFileData?.name}}{{scanCopyFileUploadConfig?.uploadedFileData?.extension}}
              </a>
            </ng-container>

            <ng-template #noFileChoose>
              No File Chosen
            </ng-template>

            <ng-container *ngIf="scanCopyFileUploadConfig?.uploadedFileData?.file">
              <mat-icon class="mat-primary-color hand-cursor m-l-10 m-r-10" matTooltip="DELETE"
                (click)="onDeleteFile($event, scanCopyFileUploadConfig.uploadedFileData.fileId)">
                delete
              </mat-icon>
            </ng-container>
            <mat-icon [matTooltip]="getInfoTooltip('Digital Copy')" class="info-icon">help_outline</mat-icon>
          </mat-grid-tile>

          <mat-grid-tile>
            <greydom-date-picker
              label="End Date"
              [formControl]="endDateContractFormControl"
              [tooltip]="getInfoTooltip('End Date Contract')"
              [minDate]="startDateContractFormControl.value">
            </greydom-date-picker>
          </mat-grid-tile>
        </mat-grid-list>

        <mat-grid-list cols="2" [rowHeight]="listFormRowHeight">
          <mat-grid-tile>
            <mat-form-field>
              <mat-label>Administrator</mat-label>
              <mat-select [formControl]="administratorFormControl">
                <mat-option *ngFor="let administrator of administrators" [value]="administrator">
                  {{administrator.name}}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-icon [matTooltip]="getInfoTooltip('Administrator Contract')" class="info-icon">help_outline</mat-icon>
          </mat-grid-tile>

        </mat-grid-list>


        <div class="align-center">
          <mat-error class="left-content claim-column-label" *ngIf="!contractsRequiredFieldsSelected">All Fields Except
            Digital Copy are mandatory
          </mat-error>
          <button mat-raised-button color="primary" (click)="addContract()">Add Contract</button>
        </div>


        <mat-divider style="margin-bottom: 16px;margin-top: 16px;" *ngIf="selectedContracts.length > 0"></mat-divider>
        <div *ngIf="selectedContracts && selectedContracts.length > 0" class="left-content">
          <label class="column-label claim-column-label">Selected Contracts</label>
        </div>
        <div class="left-content reporting-list" *ngFor="let contract of selectedContracts">
          <mat-icon class="table-icon" matTooltip="REMOVE Contract" (click)="removeContract(contract)">delete</mat-icon>
          <mat-icon class="table-icon" matTooltip="EDIT Contract" (click)="editContract(contract)">edit</mat-icon>
          <p>
            {{getContractDisplayString(contract)}}
          </p>
        </div>
        <div class="button-container">
          <button #contractBackButton mat-raised-button matStepperPrevious color="primary">Back</button>
          <button #contractClearButton mat-raised-button color="warn"
                  [disabled]="!isAllowedToSubmit()"
                  (click)="resetContractFormGroup()">
            Clear
            <mat-icon *ngIf="!isAllowedToSubmit()" class="info-icon"
                      [matTooltip]="getClearButtonTooltip()">
              help_outline
            </mat-icon>
          </button>
          
          <button #finishButton mat-raised-button color="primary"
                  [disabled]="isFinishButtonDisabled()"
                  (click)="submitProvider()">Finish
            <mat-icon *ngIf="isFinishButtonDisabled()" class="info-icon"
                      [matTooltip]="getFinishButtonTooltip()">help_outline
            </mat-icon>
          </button>
        </div>
      </form>
    </mat-step>
  </mat-horizontal-stepper>
</div>
